import i18n from '../../i18n';
import {
  rfcRegex,
  curpRegex,
  emailRegex,
  passwordRegex,
} from '../../utils/validators';
import { sanitationUtil, validationUtil } from '../../utils/fieldUtils';

export const LoginSteps = {
  ENTER_USER_AND_PASSWORD: 0,
  TWO_FACTOR_AUTHENTICATION: 1,
};

export const TwoFactorMethods = {
  PASSKEY: 'PASSKEY',
  TOTP: 'TOTP',
};

export const TokenTypes = {
  ACCESS: 'ACCESS',
  TWO_FACTOR: 'TWO_FACTOR',
};

/**
 * @type {import('react-hook-form').RegisterOptions}
 */
export const UserInputRules = {
  required: i18n.t('login:fieldRequired'),
  validate: (value) =>
    rfcRegex.test(value) ||
    curpRegex.test(value) ||
    emailRegex.test(value) ||
    i18n.t('login:invalidUser'),
};

/**
 * @type {import('react-hook-form').RegisterOptions}
 */
export const PasswordInputRules = {
  required: i18n.t('login:fieldRequired'),
  validate: (value) =>
    passwordRegex.test(value) || i18n.t('login:invalidPassword'),
};

/**
 * @param {string} value - The input value to be sanitized.
 * @returns {string} - The sanitized input value.
 */
export const userSanitizer = (value) => {
  if (validationUtil.email(value)) {
    return sanitationUtil.email(value);
  }
  if (validationUtil.rfc(value)) {
    return sanitationUtil.rfc(value);
  }
  if (validationUtil.curp(value)) {
    return sanitationUtil.curp(value);
  }
  return value;
};
